import React from "react";
import {WooContext} from "../WooContext";
import {allProductsUrl} from "../Elements/consts";

function Breadcrumb() {
    const {pageInfoState, currentCategoryState} = React.useContext(WooContext);
    const [{name}] = pageInfoState;
    const [currentCategory] = currentCategoryState;
 return (
     <div className="woocommerce-breadcrumb" itemProp="breadcrumb">
     <div className="inner-container">
         <a href="/">Home</a>
         <span className="delimiter"> | </span>
         <a href={allProductsUrl}>Products</a>
         {currentCategory.databaseId ?
                 currentCategory.parent && currentCategory.parent.node.databaseId &&
             <><span className="delimiter"> | </span><a href={currentCategory.parent.node.uri}>{currentCategory.parent.node.name}</a></> : ''
         }
         {name && <><span className="delimiter"> | </span>{name}</>}
        </div>
    </div>
    )
}

export default Breadcrumb;